import { useState, useEffect, useCallback, useRef } from "react";

type Notification = {
  id: number;
  message: string;
  position: "bottom-left" | "bottom-right";
};

const PLAYLIST_NAMES = [
  "Summer Vibes",
  "Chill Beats",
  "Workout Mix",
  "90s Hits",
  "Road Trip",
  "Late Night",
  "Indie Mix",
  "Hip Hop",
  "Rock Classics",
  "Electronic",
  "Acoustic",
  "Party Mix",
  "Morning Chill",
  "Focus",
  "K-Pop Mix",
  "Latin Hits",
  "R&B Smooth",
  "Throwback",
  "Feel Good",
  "Gym Mix",
];

const MESSAGES = [
  (name: string) => `"${name}" converted`,
  (name: string) => `${name} → vinyl`,
  (name: string) => `${name} haul ready`,
];

const TIME_LABELS = ["now", "2s", "5s", "15s", "30s"];

const POSITIONS: Notification["position"][] = ["bottom-left", "bottom-right"];

const getRandomItem = <T,>(arr: T[]): T => arr[Math.floor(Math.random() * arr.length)];

export const SocialProof = (): JSX.Element => {
  const [notifications, setNotifications] = useState<Notification[]>([]);
  const notificationIdRef = useRef(0);

  const createNotification = useCallback(() => {
    const playlistName = getRandomItem(PLAYLIST_NAMES);
    const messageTemplate = getRandomItem(MESSAGES);
    const timeLabel = getRandomItem(TIME_LABELS);
    const position = getRandomItem(POSITIONS);

    const id = notificationIdRef.current++;
    const newNotification: Notification = {
      id,
      message: `${messageTemplate(playlistName)} · ${timeLabel}`,
      position,
    };

    setNotifications((prev) => [...prev, newNotification]);

    // Remove after animation (shorter duration)
    setTimeout(() => {
      setNotifications((prev) => prev.filter((n) => n.id !== id));
    }, 3000);
  }, []);

  useEffect(() => {
    // Initial delay before first notification
    const initialDelay = setTimeout(() => {
      createNotification();
    }, 4000);

    // Random interval between notifications (5-10 seconds)
    const interval = setInterval(() => {
      createNotification();
    }, 5000 + Math.random() * 5000);

    return () => {
      clearTimeout(initialDelay);
      clearInterval(interval);
    };
  }, [createNotification]);

  return (
    <div className="social-proof-container" aria-live="polite" aria-atomic="false">
      {notifications.map((notification) => (
        <div
          key={notification.id}
          className={`social-proof-toast ${notification.position}`}
        >
          <span className="social-proof-text">{notification.message}</span>
        </div>
      ))}
    </div>
  );
};
